<template>
    <div>
        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-6">
                <h4>Darbinieku grupas</h4>
            </div>
            <div class="col-sm-6 d-flex justify-content-end">
                <UsersGroupsAdd/>
            </div>
        </div>
        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <UsersGroupsList v-else/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import UsersGroupsList from '@/components/users-groups/UsersGroupsList';
    import UsersGroupsAdd from '@/components/users-groups/UsersGroupsAdd';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
    import SkeletonLoader from '@/components/global/skeleton-loader/SkeletonLoader';

    export default {
        name: 'users',
        components: {UsersGroupsList, UsersGroupsAdd, SkeletonLoader},
        data: () => ({searchTerm: '', skeletonData: SkeletonLoaderRepository.usersListLayout}),
        computed: {
            ...mapGetters('user', {
                /** @type {Company|*} */
                isLoading: userStoreTypes.GET_IS_LOADING,
            })
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                getUsers: userStoreTypes.ACTION_GET_USERS,
            }),
            /**
             * Search company by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);

                this.searchTimeout = setTimeout(async () => {
                    const users = await this.getUsers({companyId: this.$route.params.companyId, name: this.searchTerm});
                    this.setCurrentCompanyUsers(users);
                }, 500);
            },
        }
    }
</script>
